import { CheckCircle2 } from "lucide-react"
import { cn } from "@/lib/utils"

export function CheckIndicator({ selected }) {
  return (
    <div
      className={cn(
        "flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors",
        selected ? "border-primary bg-primary" : "border-border bg-background",
      )}
    >
      {selected ? <CheckCircle2 className="h-3 w-3 text-primary-foreground" /> : null}
    </div>
  )
}

export function SelectableCard({
  selected,
  onClick,
  disabled = false,
  variant = "primary",
  padding = "p-4",
  bg = "bg-background",
  children,
  ...buttonProps
}) {
  const selectedClasses = variant === "secondary"
    ? "border-primary/50 bg-primary/5"
    : "border-primary bg-primary/5 shadow-md"
  const idleHover = variant === "secondary"
    ? "hover:border-muted-foreground/30"
    : "hover:border-primary/50"
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={cn(
        "w-full rounded-xl border text-left transition-all disabled:cursor-not-allowed disabled:opacity-50",
        padding,
        selected ? selectedClasses : `border-border ${bg} ${idleHover}`,
      )}
      {...buttonProps}
    >
      {children}
    </button>
  )
}
